module.exports = __webpack_public_path__ + "assets/img/logo-unionpay.51363dbb.png";